import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const LocalSearchAlgorithms = () => (
  <AIModuleSubtopic
    title="Local Search algorithms-Hill-climbing search, Simulated annealing, Genetic Algorithm"
    videos={[
      "https://www.youtube.com/embed/deT2kSJQKEI",
      "https://www.youtube.com/embed/ppV0sJUfqhQ",
      "https://www.youtube.com/embed/ct9rpyxbgaE",
      "https://www.youtube.com/embed/96-u9s6D16k",
      "https://www.youtube.com/embed/InVJWW_NzFY"
    ]}
    takeaways={[
      { text: "Understand the structure and operation of hill-climbing, simulated annealing, and genetic algorithms." },
      { text: "Recognize the strengths and limitations of each local search method." }
    ]}
    questions={[
      {
        text: "Explain each step of the genetic algorithm with correct terminology in detail using the eight-queen problem and appropriate examples. Calculations must be provided along with the steps when necessary."
      },
      {
        text: "Suppose a genetic algorithm uses chromosomes of the form x=abcdefgh with a fixed length of eight genes. Each gene can be any digit between 0 and 9. Let the fitness of individual x be calculated as: f(x)=(a+b)-(c+d)+(e+f)-(g+h) and let the initial population consist of four individuals with the following chromosomes. Evaluate each individual's fitness, showing all your workings and arranging them in order with the fittest first and the least fit last.",
        image:"/ai_20.png"
      },
      {
        text: "With a neat sketch of the hill-climbing algorithm's state-space landscape, explain why the hill-climbing search gets stuck. List the variants of the hill climbing algorithm and describe how they overcome this problem."
      },
      {
        text: "Discuss the salient features of local search algorithms and explain their state-space landscape."
      },
      {
        text: "Explain the Steepest ascent Hill climbing algorithm. Discuss the situations under which Hill Climbing may fail to find a solution. What can be done to overcome these situations?"
      },
      {
        text: "Explain the Hill Climbing Search Algorithm. What are the advantages and disadvantages of the algorithm? What is the strategy used in Simulated Annealing that helps it to escape Local Minima?"
      },
      {
        text: "Elucidate the pseudocode of the simulated annealing algorithm and 'In simulated annealing acceptance probability is designed in such a way that, as the number of iterations increases, the probability of accepting bad performance comes down'- Justify the above statement with a suitable example."
      },
      {
        text: "The hill-climbing search algorithm moves to the best successor of the current node according to an objective function. Consider the 8-puzzle problem with the following start state and goal state. Use evaluation function f(n) as 'number of tiles out of place' and solve the following using the Hill climbing algorithm.",
        image:"/ai_21.png"
      },
      {
        text: "Genetic algorithm is the bio-inspired computational intelligence algorithm and it reflects the process of natural selection and genetics -Justify."
      },
      {
        text: "A manufacturing plant aims to create an optimal production schedule that reduces production time and efficiently utilizes resources. Discuss how hill climbing could be applied to determine a feasible schedule, highlighting potential obstacles. Also, illustrate how simulated annealing can be used to overcome suboptimal solutions and achieve a better schedule."
      },
      {
        text: "Show that hill-climbing approach suffers from local optima in solving a problem. Use a global heuristic function to solve the same problem to reach the goal state."
      },
      {
        text: "Explain how simulated annealing can address the plateau problem in hill climbing. Provide an example to illustrate this solution."
      },
      {
        text: "A manufacturing facility has a set of jobs to be processed on a set of machines. Each job has a specific processing time on each machine. The goal is to schedule the jobs on the machines in a way that minimizes the total completion time by using the genetic algorithm. Consider that there are 4 jobs (A, B, C, D) and 2 machines (M1, M2). Jobs can be processed on any of the machines. For e.g., job A can be processed on either M1 or M2. The processing times (in minutes) for each job on each machine are given in the following table: [Hint to create the initial population: Chromosome 1: A(M1)B(M2)C(M1)D(M1). The fitness value of this is 3+4+4+5 = 16].",
        image:"/ai_22.png"
      },
      {
        text: "Compare and contrast Hill Climbing search and Simulated Annealing, highlighting their strengths and weaknesses."
      }
    ]}
    exampleVideos={[]}
  />
);

export default LocalSearchAlgorithms;
